let open = false
const listeners = new Set<() => void>()

function emit(): void {
  listeners.forEach((listener) => listener())
}

export function openQuickProblemMarkModal(): void {
  open = true
  emit()
}

export function closeQuickProblemMarkModal(): void {
  open = false
  emit()
}

export function getQuickProblemMarkModalOpen(): boolean {
  return open
}

export function subscribeQuickProblemMarkModal(listener: () => void): () => void {
  listeners.add(listener)
  return () => listeners.delete(listener)
}
